import React from "react";

const PopupAdvertise = ({ adImageData, onClose }) => {
  if (!adImageData || adImageData.length === 0) return null;

  const { mainImage, linkUrl, title } = adImageData[0];

  return (
    <div className="popup-ad-section">
      <div className="overlay" onClick={onClose}></div>

      <div className="popup-wrapper">
        <div className="popup-image-box">
          <a href={linkUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={mainImage}
              alt={title}
              title={title}
              className="popup-image"
            />
          </a>
          <button className="close-btn" onClick={onClose} aria-label="Close">
            <span className="close-x">×</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupAdvertise;
